import PodcastLandingPage from './PodcastLandingPage';

export default PodcastLandingPage;
